import config from './config';

const DEFAULT_CARVERTICAL = {
    url: 'https://www.carvertical.deal/31HLNSB/5NWWWN/?source_id=AFF&sub1=worldauto',
    partner: 'carvertical',
    promoCode: 'worldauto',
    discount: '20%',
};

export const getVinAffiliate = () => {
    const vin = config.affiliates?.vin;
    if (vin && vin.url) {
        return {
            url: vin.url,
            partner: vin.partner || DEFAULT_CARVERTICAL.partner,
            promoCode: vin.promoCode || DEFAULT_CARVERTICAL.promoCode,
            discount: vin.discount || DEFAULT_CARVERTICAL.discount,
        };
    }
    return { ...DEFAULT_CARVERTICAL };
};
